import { auth } from './firebaseApp'
import {
  ActionCodeSettings,
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signInWithPopup,
} from 'firebase/auth'

const googleProvider = new GoogleAuthProvider()

export function signInWithGoogle() {
  return signInWithPopup(auth, googleProvider)
}

export function loginWithPassword(email: string, password: string) {
  return signInWithEmailAndPassword(auth, email, password)
}

export function signUpWithPassword(email: string, password: string) {
  return createUserWithEmailAndPassword(auth, email, password)
}

export function requestPasswordReset(email: string, options: ActionCodeSettings) {
  return sendPasswordResetEmail(auth, email, options)
}

export const firebaseUser = auth.currentUser
